import {useRef, useState} from "react";
import styled from "styled-components";
import PhoneFillIcon from "../icons/PhoneFillIcon/PhoneFillIcon";
import {useClickOutside} from "../../utils/click/handle-click";

interface Props {
    phone?: string;
}

export const LineNameCardPhoneDialog: React.FC<Props> = ({phone}) => {
    const ref = useRef<HTMLDivElement>(null);
    const [open, setOpen] = useState<boolean>(false);

    const handlePhoneDialog = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        setOpen(!open);
    };

    useClickOutside(ref, () => setOpen(false));

    return (
        <PhoneIconContainer
            ref={ref}
            onClick={handlePhoneDialog}
            className={`${phone ? "" : " disabled "} ${open ? "open" : ""}`}
        >
            <PhoneFillIcon width="14px" height="14px"/>
            {open && phone && <PhoneDialog>{phone}</PhoneDialog>}
        </PhoneIconContainer>
    );
};

const PhoneIconContainer = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 2px;
  box-sizing: border-box;

  & svg path {
    fill: ${(props) => props.theme.palette.primitives.gray400};
  }

  &:active {
    background: ${(props) => props.theme.palette.primitives.gray50};
  }

  &.open {
    background: ${(props) => props.theme.palette.primitives.gray50};
  }

  &.disabled {
    background: transparent;
  }

  &:hover {
    & svg path {
      fill: ${(props) => props.theme.palette.primitives.gray500};
    }
  }

  &.disabled svg path {
    fill: ${(props) => props.theme.palette.primitives.gray200};
  }

  &.disabled:hover, &.disabled:active: {
    fill: ${(props) => props.theme.palette.primitives.gray200};
  }
`;

const PhoneDialog = styled.div`
  position: absolute;
  padding: 6px 0;
  text-align: center;
  box-sizing: border-box;
  width: 116px;
  height: 27px;
  top: calc(100%);
  left: calc(50% - 116px / 2);
  border: 1px solid ${(props) => props.theme.palette.primitives.gray200};
  background: ${(props) => props.theme.palette.primitives.white};
  border-radius: 2px;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  color: ${(props) => props.theme.palette.primitives.gray800};
  transition: 1s ease-in;
  z-index: 999;
`;
